import React__default from 'react';
import { FONT_WEIGHT_MAP, getTypographySize } from './helper.es.js';
import { CommonStyles } from '../BaseProps/index.es.js';
import styled from '@emotion/styled';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const StyledTypography = styled.div`
  margin: 0;
  padding: 0;
  ${CommonStyles}
  color: ${(p) => p.theme.colors[p.color] || p.color || "inherit"};
  font-weight: ${(p) => (p.weight ? FONT_WEIGHT_MAP[p.weight] : FONT_WEIGHT_MAP[getTypographySize(p.type, p.level, "fontWeight")]) || 500};
  text-decoration: ${(p) => p.decoration || "unset"};
  font-size: ${(p) => getTypographySize(p.type, p.level, "fontSize")};
  line-height: ${(p) => getTypographySize(p.type, p.level, "lineHeight")};
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: ${(p) => p.line || "unset"};
  max-width: ${(p) => p.maxWidth ? `${p.maxWidth}px` : "unset"};
  min-width: ${(p) => p.minWidth ? `${p.minWidth}px` : "unset"};
  transition: color 0.3s ease;
  ${(p) => p.hoverColor ? `&:hover {
    color: ${p.theme.colors[p.hoverColor] || p.hoverColor};
  }` : ""};
`;
const Heading = (_a) => {
  var _b = _a, { level = 4 } = _b, props = __objRest(_b, ["level"]);
  return /* @__PURE__ */ React__default.createElement(StyledTypography, __spreadValues({
    type: "heading",
    as: `h${level}`,
    level
  }, props));
};
const Title = (_c) => {
  var _d = _c, { level = 2 } = _d, props = __objRest(_d, ["level"]);
  return /* @__PURE__ */ React__default.createElement(StyledTypography, __spreadValues({
    type: "title",
    level
  }, props));
};
const SubTitle = (_e) => {
  var _f = _e, { level = 4 } = _f, props = __objRest(_f, ["level"]);
  return /* @__PURE__ */ React__default.createElement(StyledTypography, __spreadValues({
    type: "subtitle",
    level
  }, props));
};
const Body = (_g) => {
  var _h = _g, { level = 2 } = _h, props = __objRest(_h, ["level"]);
  return /* @__PURE__ */ React__default.createElement(StyledTypography, __spreadValues({
    type: "body",
    level
  }, props));
};
const Caption = (_i) => {
  var _j = _i, { level = 3 } = _j, props = __objRest(_j, ["level"]);
  return /* @__PURE__ */ React__default.createElement(StyledTypography, __spreadValues({
    type: "caption",
    level
  }, props));
};

export { Body, Caption, Heading, SubTitle, Title };
